module.exports = __webpack_public_path__ + "img/yonghu1.bbd5535f.png";